import { css } from 'styled-components';
const sharedCSS = css `
  padding: 0 12px;
  user-select: none;
  min-height: 38px;
  height: 38px;
  box-sizing: border-box;
  border-radius: 8px;
  overflow: hidden;
  border-width: 1px;
  border-style: solid;
  background-color: inherit;
  outline: none;
  ${({ theme }) => theme.fonts.PoppinsTextMedium};
  font-size: 14px;
  input {
    ${({ theme }) => theme.fonts.PoppinsTextMedium};
    font-size: 14px;
    color: inherit;
    cursor: inherit;
    &::placeholder {
      color: inherit;
      cursor: inherit;
      ${({ theme }) => theme.fonts.PoppinsTextMedium};
      font-size: 14px;
    }
  }
`;
const errorCSS = css `
  ${({ isError }) => isError &&
    css `
      border-color: ${({ theme }) => theme.colors.ErrorDefault};
    `};
`;
export const BKJThemeSelect = {
    PurpleOutlined: {
        colorScheme: {
            fontColor: () => {
                return 'PrimaryDefault';
            },
            bgColor: () => {
                return 'White';
            },
        },
        css: css `
      ${sharedCSS};
      background-color: ${({ theme }) => theme.colors.White};
      border-color: ${({ theme }) => theme.colors.PrimaryDefault};
      color: ${({ theme }) => theme.colors.PrimaryDefault};
      ${errorCSS};
    `,
    },
    PurpleSolid: {
        colorScheme: {
            fontColor: () => {
                return 'TextWhite';
            },
            bgColor: () => {
                return 'PrimaryDefault';
            },
        },
        css: css `
      ${sharedCSS};
      background-color: ${({ theme }) => theme.colors.PrimaryDefault};
      border-color: ${({ theme }) => theme.colors.PrimaryDefault};
      color: ${({ theme }) => theme.colors.TextWhite};
      ${errorCSS};
    `,
    },
    PurpleSolidPill: {
        colorScheme: {
            fontColor: () => {
                return 'TextWhite';
            },
            bgColor: () => {
                return 'PrimaryDefault';
            },
        },
        css: css `
      ${sharedCSS};
      background-color: ${({ theme }) => theme.colors.PrimaryDefault};
      border-color: ${({ theme }) => theme.colors.PrimaryDefault};
      color: ${({ theme }) => theme.colors.TextWhite};
      border-radius: 19px;
      ${errorCSS};
    `,
    },
    GreySolidPill: {
        colorScheme: {
            fontColor: () => {
                return 'TextDarkGrey';
            },
            bgColor: () => {
                return 'White';
            },
        },
        css: css `
      ${sharedCSS};
      background-color: ${({ theme }) => theme.colors.White};
      border-color: ${({ theme }) => theme.colors.Grey6};
      color: ${({ theme }) => theme.colors.TextDarkGrey};
      border-radius: 19px;
      ${errorCSS};
    `,
    },
    GreyOutlined: {
        colorScheme: {
            fontColor: () => {
                return 'Grey6';
            },
            bgColor: () => {
                return 'White';
            },
        },
        css: css `
      ${sharedCSS};

      background-color: ${({ theme }) => theme.colors.White};
      border-color: ${({ theme }) => theme.colors.Grey6};
      color: ${({ theme }) => theme.colors.TextDarkGrey};
      ${errorCSS};
    `,
    },
    GreyOutlinedClear: {
        colorScheme: {
            fontColor: () => {
                return 'Grey6';
            },
            bgColor: () => {
                return 'White';
            },
        },
        css: css `
      ${sharedCSS};

      background-color: ${({ theme }) => theme.colors.White};
      border-color: ${({ theme }) => theme.colors.Grey6};
      color: ${({ theme }) => theme.colors.Grey6};
      ${errorCSS};
    `,
    },
    GreyOutlinedPill: {
        colorScheme: {
            fontColor: (isOpen) => {
                return isOpen ? 'White' : 'Grey6';
            },
            bgColor: (isOpen) => {
                return isOpen ? 'PrimaryDefault' : 'White';
            },
        },
        css: css `
      ${sharedCSS};
      border-radius: 19px;
      padding: 0 10px 0 12px;
      ${({ isOpen, value }) => {
            if (isOpen || value.length)
                return css `
            background-color: ${({ theme }) => theme.colors.PrimaryDefault};
            border-color: ${({ theme }) => theme.colors.PrimaryDefault};
            color: ${({ theme }) => theme.colors.TextWhite} !important;
          `;
            return css `
          background-color: ${({ theme }) => theme.colors.White};
          border-color: ${({ theme }) => theme.colors.Grey6};
          color: ${({ theme }) => theme.colors.TextDarkGrey} !important;
        `;
        }}
      ${errorCSS};
    `,
    },
    GreyOutlinedPillClear: {
        colorScheme: {
            fontColor: (isOpen) => {
                return isOpen ? 'White' : 'Grey6';
            },
            bgColor: (isOpen) => {
                return isOpen ? 'PrimaryDefault' : 'White';
            },
        },
        css: css `
      ${sharedCSS};
      border-radius: 19px;
      padding: 0 10px 0 12px;
      ${({ isOpen, value }) => {
            if (isOpen || value.length)
                return css `
            background-color: ${({ theme }) => theme.colors.PrimaryDefault};
            border-color: ${({ theme }) => theme.colors.PrimaryDefault};
            color: ${({ theme }) => theme.colors.TextWhite};
          `;
            return css `
          background-color: ${({ theme }) => theme.colors.White};
          border-color: ${({ theme }) => theme.colors.Grey6};
          color: ${({ theme }) => theme.colors.TextDarkGrey};
        `;
        }}
      ${errorCSS};
    `,
    },
    PurpleText: {
        colorScheme: {
            bgColor: () => {
                return 'Transparent';
            },
            fontColor: () => {
                return 'PrimaryDefault';
            },
        },
        css: css `
      ${sharedCSS};
      background-color: transparent;
      border: none;
      color: ${({ theme }) => theme.colors.PrimaryDefault};
    `,
    },
    PurpleTextNoArrow: {
        colorScheme: {
            bgColor: () => {
                return 'Transparent';
            },
            fontColor: () => {
                return 'PrimaryDefault';
            },
        },
        css: css `
      ${sharedCSS};
      background-color: transparent;
      border: none;
      color: ${({ theme }) => theme.colors.PrimaryDefault};
    `,
    },
};
//# sourceMappingURL=BKJSelect.theme.js.map